import { AppointmentStatuses } from '~constants/maps';

import { FieldProps } from '~components/form-fields';

import { appointmentCancelledFields, repeatCancelledFields } from './appointment/cancelled';
import { caseManagementEditFields, caseManagementFields } from './appointment/caseManagement';
import { appointmentRepeatActiveFields, appointmentSingleActiveFields } from './appointment/completed';
import {
  appointmentEditFields,
  clientGroupChildEditFields,
  repeatAppointmentEditFields,
  repeatClientGroupChildEditFields,
} from './appointment/edit';
import { group, groupRepeat, repeat, single, supportCoordination } from './appointment/new';

export const get: (values: any) => FieldProps = (params) => {
  const {
    isNew,
    isRepeat,
    status_id,
    isSupportCoordination,
    isCaseManagement,
    isNewGroup,
    isClientGroupChild,
    participantType,
  } = params;

  const appointmentStatus = status_id ? parseInt(status_id) : null;

  switch (true) {
    case isSupportCoordination:
      return supportCoordination;

    case isCaseManagement:
      return isNew ? caseManagementFields : caseManagementEditFields;

    case isNew && isNewGroup:
      return getNewGroupFields(isRepeat, participantType);

    case isNew:
      return isRepeat ? repeat.repeatAppointmentNewFields : single.singleAppointmentNewFields;

    case appointmentStatus === AppointmentStatuses.STARTED || appointmentStatus === AppointmentStatuses.COMPLETED:
      return isRepeat ? appointmentRepeatActiveFields : appointmentSingleActiveFields;

    case appointmentStatus === AppointmentStatuses.CANCELLED:
      return isRepeat ? repeatCancelledFields : appointmentCancelledFields;

    case isClientGroupChild:
      return isRepeat ? repeatClientGroupChildEditFields : clientGroupChildEditFields;

    default:
      return isRepeat ? repeatAppointmentEditFields : appointmentEditFields;
  }
};

function getNewGroupFields(isRepeat: boolean, participantType: string): FieldProps {
  return isRepeat ? getNewRepeatGroupFields(participantType) : getNewSingleGroupFields(participantType);
}

function getNewRepeatGroupFields(participantType: string): FieldProps {
  switch (participantType) {
    case 'user':
      return groupRepeat.newRepeatGroupUser;
    case 'client':
      return groupRepeat.newRepeatGroupClient;
    default:
      return groupRepeat.newRepeatGroupParent;
  }
}

function getNewSingleGroupFields(participantType: string): FieldProps {
  switch (participantType) {
    case 'user':
      return group.newGroupUser;
    case 'client':
      return group.newGroupClient;
    default:
      return group.newGroupParent;
  }
}
